<template>
  <div class="basic_wrap">
    <div class="red_top_bg">
      <div class="back_left" @click="$router.back()">返回</div>
      <div class="big_tit">实名认证</div>
    </div>
    <div class="wrap">
      <div class="write_new_pwd">
        <div class="write_box">
          <div class="wordBox">
            <input
              v-model="realname"
              type="text"
              placeholder="请输入真实姓名"
              :disabled="!codeStatus"
            />
          </div>
        </div>
        <div class="write_box">
          <div class="wordBox">
            <input
              v-model="displayIdNumber"
              type="text"
              placeholder="请输入身份证号码"
              :disabled="!codeStatus"
              @input="handleIdNumberInput"
            />
          </div>
        </div>
      </div>
    </div>
    
    <!-- 未实名时显示认证按钮 -->
    <div v-if="codeStatus" class="basic_btn" @click="certification">
      实名认证
    </div>
    
    <!-- 已实名时显示已认证状态 -->
    <div v-else class="basic_btn no_touch" style="background: #cccccc;">
      认证通过
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import { CountDown } from 'vant'
  import Fetch from '../../utils/fetch'
  import { Popup } from 'vant'
  import { PasswordInput, NumberKeyboard } from 'vant'

  Vue.use(PasswordInput)
  Vue.use(NumberKeyboard)
  Vue.use(Popup)
  Vue.use(CountDown)

  export default {
    name: 'Setrealinfo',
    data() {
      return {
        realname:"",
        idNumber:"", // 存储完整的身份证号（用于提交）
        displayIdNumber: "", // 显示用的身份证号（已加密）
        showKeyboard: true,
        choose_tick: false,
        write_psd: false,
        time: 0,
        password: '',
        rpassword: '',
        npassword: '',
        mobile: '',
        ycmobile: '',
        passwordInp: 'password',
        newpasswordInp: 'password',
        codeStatus: true, // true: 未实名, false: 已实名
        psd_val: '',
        codeOK: false,
        code: '',
        is_send: false,
        nowInput: 1,
      }
    },
    created() {
      this.$parent.footer('user', false);
      this.checkName();
    },
    mounted() {
      document.getElementById('app').style.background =
        'linear-gradient(to bottom, #5674d3, #a8b6e5)'
      document.getElementById('app').style.marginBottom = '0px'
      Fetch('/user/info').then((r) => {
        this.mobile = r.data.mobile
        this.ycmobile = r.data.mobile.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
      })
    },
    watch: {
      displayIdNumber(newVal) {
        // 监听显示用的身份证号，同步到实际提交的idNumber（仅在未实名状态）
        if (this.codeStatus) {
          this.idNumber = newVal;
        }
      },
      idNumber(newVal) {
        if (this.codeStatus) {
          // 未实名状态，显示原始输入
          this.displayIdNumber = newVal;
        } else {
          // 已实名状态，显示加密后的
          this.displayIdNumber = this.encryptIdCard(newVal);
        }
      }
    },
    methods: {
      // 处理身份证号输入
      handleIdNumberInput(event) {
        if (this.codeStatus) {
          this.idNumber = event.target.value;
        }
      },
      
      // 加密身份证号：显示前4位和后4位，中间用*代替
      encryptIdCard(idCard) {
        if (!idCard || idCard.length < 8) {
          return idCard;
        }
        
        const firstFour = idCard.substring(0, 4);
        const lastFour = idCard.substring(idCard.length - 4);
        const middleStars = '*'.repeat(idCard.length - 8);
        
        return firstFour + middleStars + lastFour;
      },
      
      checkName(){
        Fetch('/user/check_auth',{})
        .then((res)=>{
          // 修正判断逻辑：is_auth 为 "Y" 表示已实名，"N" 表示未实名
          this.codeStatus = res.data.is_auth !== 'Y'; // 如果是 "Y" 则 codeStatus 为 false（已实名）
          
          // 设置姓名和身份证号
          this.realname = res.data.name || "";
          this.idNumber = res.data.idcard || "";
          
          // 如果已实名，显示加密的身份证号；如果未实名，显示原始输入
          if (this.codeStatus) {
            this.displayIdNumber = this.idNumber;
          } else {
            this.displayIdNumber = this.encryptIdCard(this.idNumber);
          }
          
          console.log('实名状态:', res.data.is_auth, '可编辑状态:', this.codeStatus);
        })
        .catch((error) => {
          console.error('获取实名状态失败:', error);
          // 如果请求失败，默认设为未实名状态
          this.codeStatus = true;
          this.displayIdNumber = this.idNumber;
        })
      },
      
      certification(){
        console.log('认证信息:', {
          姓名: this.realname,
          身份证: this.idNumber,
          显示身份证: this.displayIdNumber
        });
        
        if (!this.realname || this.realname.trim() === '') {
          this.$toast('请输入姓名')
          return false
        }
        if (!this.idNumber || this.idNumber.trim() === '') {
          this.$toast('请输入身份证号码')
          return false
        }
        
        // 最宽松的身份证验证：只要有数字就行
        // if (!this.validateIdCard(this.idNumber)) {
        //   this.$toast('身份证号码格式不正确')
        //   return false
        // }
        
        let data = {
          name: this.realname,
          idcard: this.idNumber
        }
        
        Fetch('/user/auth_email', data)
        .then((res)=>{
          if (res.code === 1) {
            this.$toast('认证成功');
            // 认证成功后加密显示
            this.displayIdNumber = this.encryptIdCard(this.idNumber);
            this.checkName(); // 重新检查实名状态
          } else {
            this.$toast(res.info || '认证失败');
          }
        })
        .catch(() => {
          this.$toast('认证请求失败');
        })
      },
      
      // 最宽松的身份证验证：只要有数字就行
      // validateIdCard(idCard) {
      //   if (!idCard || idCard.trim() === '') {
      //     return false;
      //   }
        
      //   // 只要有数字就通过（无论位置、无论多少位）
      //   const hasNumbers = /\d/.test(idCard);
      //   return hasNumbers;
      // },
      
      showWord(n) {
        n == 1 ? (this.nowInput = 1) : (this.nowInput = 2)
        this.psd_val = ''
        this.write_psd = true
      },
      
      onInput(key) {
        this.psd_val = (this.psd_val + key).slice(0, 6)
        if (this.psd_val.length == 6) {
          if (this.nowInput == 1) {
            this.npassword = this.psd_val
          } else {
            this.rpassword = this.psd_val
          }
          this.write_psd = false
        }
      },
      
      onDelete() {
        this.psd_val = this.psd_val.slice(0, this.psd_val.length - 1)
      },
      
      cutType(n) {
        n == 1 ? (this.codeStatus = true) : (this.codeStatus = false)
        this.rpassword = ''
        this.npassword = ''
      },
      
      timeCall() {
        this.is_send = false
        this.time = 0
      },
      
      sendcode() {
        if (this.is_send) {
          return
        }

        this.is_send = true

        Fetch('/index/forgetpwd_email_code', {
          mobile: this.mobile,
        })
          .then(() => {
            this.time = 60 * 1000
            this.$toast({
              className: 'toastName',
              message: this.$t('setpwd.sendsuccessfully'),
            })
          })
          .catch(() => {
            this.is_send = false
          })
      },
      
      showPwd() {
        this.passwordInp == 'password'
          ? (this.passwordInp = 'text')
          : (this.passwordInp = 'password')
      },
      
      showNewsPwd() {
        this.newpasswordInp == 'password'
          ? (this.newpasswordInp = 'text')
          : (this.newpasswordInp = 'password')
      },
      
      dxRevise() {
        if (!this.npassword) {
          this.$toast(this.$t('setpaypwd.newpasswordcannotbeempty'))
          return false
        }

        if (this.npassword !== this.rpassword) {
          this.$toast(this.$t('setpaypwd.inconsistent'))
          return false
        }

        Fetch('/user/resetpaypwd_code', {
          code: this.code,
          npassword: this.npassword,
        }).then(() => {
          this.$toast({
            className: 'toastName',
            message: this.$t('setpwd.modifiedsuccessfully'),
          })

          sessionStorage.setItem('pwd', this.npassword)

          if (this.$route.query.redirect) {
            this.$router.replace(this.$route.query.redirect + '?change')
          } else {
            this.$router.replace('/safe')
          }
        })
      },
      
      oldRevise() {
        if (!this.password) {
          this.$toast(this.$t('setpaypwd.loginpasswordcannotbeempty'))
          return false
        }

        if (!this.npassword) {
          this.$toast(this.$t('setpaypwd.newpasswordcannotbeempty'))
          return false
        }

        if (this.npassword !== this.rpassword) {
          this.$toast(this.$t('setpaypwd.inconsistent'))
          return false
        }
        
        var reg = new RegExp('^[0-9]*$')
        if (!reg.test(this.npassword)) {
          this.$toast(this.$t('setpaypwd.pureNumber'))
          return false
        }
        
        if (!reg.test(this.rpassword)) {
          this.$toast(this.$t('setpaypwd.pureNumber'))
          return false
        }
        
        Fetch('/user/resetpaypwd', {
          passwd: this.password,
          npasswd: this.npassword,
        }).then(() => {
          this.$toast({
            className: 'toastName',
            message: this.$t('setpwd.modifiedsuccessfully'),
          })

          this.$router.replace('/safe')
        })
      }
    }
  }
</script>

<style lang="less" scoped>
  .red_top_bg {
    height: 168px;
    background: linear-gradient(to left, #5674d3, #a8b6e5);
    height: 50px;
  }

  .big_tit {
    color: #fff;
  }
  
  .wrap {
    padding: 15px 20px 0 20px;
  }
  
  .no_touch {
    pointer-events: none;
  }

  .write_box {
    width: 100%;
    height: 45px;
    margin-top: 32px;
    background: rgba(255, 255, 255, 1);
    border-radius: 2px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 10px;
    border-radius: 10px;
    background-color: #ffffff;

    input,
    .wordBox {
      width: 100%;
      height: 22px;
      line-height: 22px;
      font-size: 16px;
    }
    
    /* 禁用状态的样式 */
    input:disabled {
      background-color: #f5f5f5;
      color: #666;
      opacity: 1;
      -webkit-text-fill-color: #666;
    }
  }

  .basic_btn {
    margin: 43px auto 0 auto;
    height: 45px;
    line-height: 45px;
    font-size: 16px;
    width: 90%;
    background: linear-gradient(to left, #756ff3, #399ffe);
    border-radius: 10px;
    color: #ffffff !important;
    text-align: center;
    margin-top: 20px !important;
    
    /* 已实名状态的样式 */
    &.no_touch {
      background: #cccccc;
      color: #666 !important;
    }
  }

  .write_new_pwd {
    .write_box:first-child {
      margin-bottom: 18px;
      margin-top: 0px;
    }

    .write_box:last-child {
      margin-top: 0px;
    }
  }

  /* 其他样式保持不变 */
  /deep/ .van-password-input {
    margin: 50px 28px 0 28px;
  }

  /deep/ .van-hairline--left::after {
    border: 1px solid #ececec;
  }

  .van-password-input .van-password-input__security::after {
    border-radius: 0;
  }

  .keybord_box {
    height: 250px;
    background-color: #f0f0f0;
    margin-top: 35px;
    padding: 24px 12px 0 12px;
    .keybord {
      width: 361px;
      margin: 24px auto 0 atuo;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      text-align: center;
      .key_item {
        width: 115px;
        height: 44px;
        line-height: 44px;
        font-size: 18px;
        font-weight: bold;
        margin-bottom: 6px;
        background: rgba(255, 255, 255, 1);
        border-radius: 3px;
        &.no_bg {
          background: none;
        }
        &.x {
          color: #757880;
          font-weight: bold;
        }
      }
    }
  }
</style>